import * as React from 'react'
import { WhatsappModuleProps } from './types'
import { ModuleLayout } from '../../components/ModuleLayout'
import './index.scss'
import { RedirectButton } from '../../components/RedirectButton'

export const WhatsappModule: React.FC<WhatsappModuleProps> = ({
  cellphoneNumber,
  moduleTitleMobile,
  imageDescription,
  moduleTitleDesktop,
  qrCodeImage,
  redirectButtons,
  titleDescription,
  kinds,
}: WhatsappModuleProps) => {
  const safeRedirectButtons = redirectButtons ?? kinds

  return (
    <ModuleLayout>
      <div className="whatsapp-container">
        <div className="module-content">
          <h1 className="module-title">{moduleTitleDesktop}</h1>
          <h1 className="module-title-mobile">{moduleTitleMobile}</h1>
          <p className="module-title-description">{titleDescription}</p>
          <div className="qr-code-image-container">
            <img className="qr-code-image" src={qrCodeImage} alt="QR code Whatsapp" height={125} width={128} />
          </div>
          <p className="cellphone-text">{cellphoneNumber}</p>
          <p className="image-description">{imageDescription}</p>
        </div>
        {safeRedirectButtons ? (
          <div className="buttons-container">
            {safeRedirectButtons.map((redirectButton) => {
              const title = redirectButton.title ?? redirectButton.redirectButtonTitle
              const safeTitle = title ?? ''

              const href = redirectButton.href ?? redirectButton.redirectButtonHref
              const safeHref = href ?? ''

              return <RedirectButton key={safeTitle} title={safeTitle} href={safeHref} kind={redirectButton.kind ?? redirectButton.kindId} section="WhatsApp" />
            })}
          </div>
        ) : null}
      </div>
    </ModuleLayout>
  )
}
